// component
import Movie from "../common/ui/movie.es6";
import Modal from "../common/ui/modal.es6";

export default class InitModal {
    constructor() {
        this.initModalJsonPath = "../assets/data/tour_initmodal.json";
        this.movie = new Movie();
        this.modal = new Modal();
        this.modal.eventBind();
        this.movie.eventBind();
        this._init();
    }

    _init() {
        this._initModal();
        this.showImgModal();
    }

    async _initModal() {
        try {
            // セッションストレージに履歴がある場合は何もしない
            const modalOpened = sessionStorage.getItem("modalOpened");
            if (modalOpened) return;

            const data = await this._fetchModalData();
            this._processModalData(data);
        } catch (error) {
            console.error("Modalの初期化中にエラーが発生しました:", error);
        }
    }

    async _fetchModalData() {
        const response = await fetch(this.initModalJsonPath);
        return await response.json();
    }

    async _processModalData(data) {
        const startDate = new Date(data.startdate);
        const endDate = new Date(data.enddate);
        const now = new Date();

        if (now >= startDate && now <= endDate) {
            if (data.modal_type === "movie") {
                await this._setupMovieModal(data.youtube_id);
            } else if (data.modal_type === "imglink") {
                this._setupImageLinkModal(data.img_src, data.link_url);
            } else {
                this._setupImageModal(data.img_src);
            }

            // セッションストレージに履歴を追加
            sessionStorage.setItem("modalOpened", "true");
        }
    }

    async _setupMovieModal(youtubeId) {
        await this._waitForPlayerInitialization();

        setTimeout(() => {
            this.modal.autoOpen("movie");
            this.movie.loadVideo(youtubeId);
        }, this.delay);
    }

    _setupImageLinkModal(imgSrc, linkUrl) {
        setTimeout(() => {
            this.modal.autoOpen("imglink", imgSrc, linkUrl);
        }, this.delay);
    }

    _setupImageModal(imgSrc) {
        setTimeout(() => {
            this.modal.autoOpen("img", imgSrc);
        }, this.delay);
    }

    showImgModal() {
        const imgBtns = document.querySelectorAll(".js-modal-img");

        imgBtns.forEach((el) => {
            el.addEventListener("click", () => {
                const imgPath = el.getAttribute("src");

                setTimeout(() => {
                    this.modal.autoOpen("img", imgPath);
                }, this.delay);
            });
        });
    }

    _waitForPlayerInitialization() {
        return new Promise((resolve) => {
            const checkInterval = setInterval(() => {
                if (this.movie.player && this.movie.player.loadVideoById) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100);
        });
    }
}
